/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Simple severity ratings
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type SimpleSeverityRatingEnum = 'Low' | 'Medium' | 'High' | 'Very High';

export const SimpleSeverityRatingEnum = {
    Low: 'Low' as SimpleSeverityRatingEnum,
    Medium: 'Medium' as SimpleSeverityRatingEnum,
    High: 'High' as SimpleSeverityRatingEnum,
    VeryHigh: 'Very High' as SimpleSeverityRatingEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');

